import Homepage from "@/components/pages/Homepage";

import * as pages from "./../pageNameConstants";

export default {
  path: "/",
  name: pages.HOMEPAGE,
  component: Homepage
};
